module.exports = __webpack_public_path__ + "img/28_14.3b086fd8.png";